export default __webpack_public_path__ + "static/media/image16.36b71b0e.svg";